import React from 'react'
import { Icon, Steps } from 'antd'

const steps = [{
  key: 'register',
  title: 'Register',
  icon: 'solution'
}, {
  key: 'edit',
  title: 'Edit',
  icon: 'edit'
}, {
  key: 'review',
  title: 'Review',
  icon: 'bars'
}, {
  key: 'pay',
  title: 'Pay',
  icon: 'credit-card'
}, {
  key: 'complete',
  title: 'Complete',
  icon: 'check-circle'
}]

const RegistrationSteps = ({ step }) => {
  const current = steps.findIndex(s => s.key === step)

  return (
    <Steps current={current} style={{ padding: '26px', borderRadius: '8px 8px 0 0', borderBottom: '1px dashed gainsboro', background: 'white' }}>
      {steps.map(step => <Steps.Step title={step.title} icon={<Icon type={step.icon} />} key={step.key} />)}
    </Steps>
  )
}

export default RegistrationSteps


// WEBPACK FOOTER //
// ./src/App/components/RegistrationSteps/RegistrationSteps.js